export const bannerContentWrapper =
  'flex flex-col justify-between items-stretch px-4 bg-white textDark';

export const stackedList = 'flex flex-col gap-4 py-4 text-textDark';

export const closeButton = 'mt-4 mb-4 w-full';
